import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { DockerAccesses } from "./accesses.ts";
import { DockerComponents } from "./components.ts";

// Rule filter values compile to regular expressions, so a rule can say, e.g.,
// that `owner` in any organization needs approval.
const DockerFilters = {
  organization: { keys: ["name"] },
  role: { keys: ["name"] },
} as const satisfies AnyFilterSchema;
export type DockerFilters = typeof DockerFilters;

// Keyed by component, so a new component doesn't compile until it has one.
// The new item's form labels an item's id with its component's kind, then
// this: "Connector ID", "Organization name".
const IDENTIFIERS: Record<keyof typeof DockerComponents, string> = {
  connector: "ID",
  organization: "name",
};
// `Registration` hands `identifier` any string, not just a component key.
const identifiers: Partial<Record<string, string>> = IDENTIFIERS;

export const DockerRegistration = Registration({
  accesses: DockerAccesses,
  category: "resource",
  components: DockerComponents,
  docs: { install: "docker", request: "docker/requesting-access" },
  filters: DockerFilters,
  identifier: (component) => identifiers[component] ?? component,
  // Each component is named for what one of its items is.
  itemKind: (component) => component,
  label: "Docker Hub",
  logoUrl: "https://www.docker.com/favicon.ico",
  maturity: "beta",
  requestType: "requestable",
  useMapping: [{ component: "organization", use: "iam_write" }],
});

registerIntegration("docker", DockerRegistration);
